<template>
  <div class="container">
    <div class="bg" />
    <div id="text-holder">
      <div id="title">אופס !</div>
      <hr>
      <div id="subtitle">גם בזמן הצו יכולות להתרחש תקלות. חשוב לזכור, קשה באימונים קל בצו.</div>
    </div>
    <img src="../assets/app_logo_no_text.png" alt />
  </div>
</template>

<script>
export default {
  name: "ErrorScreen",
  data: () => {
    return {};
  }
};
</script>

<style scoped>

#text-holder {
    text-align: center;
    padding-top: 10%;
    padding-right: 20%;
    padding-left: 20%;
    direction: rtl;
}

#title {
    color: white;
    font-size: 64px;
    padding-top: 16px;
    padding-bottom: 32px;
}

img {
    padding-top: 36px;
    height: 200px;
    width: 200px;
}

#subtitle {
    color: white;
    font-size: 36px;
    padding-top: 16px;
    line-height: 32px;
}

.bg {
  background-image: url(https://storage.googleapis.com/tzav-rishon-web-assets/blurred_backpacks_bg.png);
  background-size: cover;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  position: absolute;
  z-index: -1;
}

.container {
  text-align: center;
}
</style>